export enum OperatorReasonConferenceEnded {
  conferenceEndedViaApi = 'conferenceEndedViaApi',
  lastParticipantKicked = 'lastParticipantKicked',
  lastParticipantLeft = 'lastParticipantLeft',
  participantWithEndConferenceOnExitKicked = 'participantWithEndConferenceOnExitKicked',
  participantWithEndConferenceOnExitLeft = 'participantWithEndConferenceOnExitLeft',
}
